import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap, faBook, faChalkboardTeacher } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'; // For navigation


const Education: React.FC = () => {
  const navigate = useNavigate(); // Hook for navigation

  const handleDonateClick = () => {
    navigate('/donate');
  };

  return (
    <div className="education-page">
      {/* Section 1: Hero Section with Background Image and Overlay */}
      <div className="hero-section" style={{ backgroundImage: `url('https://images.squarespace-cdn.com/content/v1/57220f5e555986178fe7d299/1559237277293-XTFNZ0DW3V968ET4CDMX/Current%2BTuirtion%2BCenter%2B1.jpg?format=1000w')` }}>
        <div className="overlay">
          <Container className="text-center py-5">
            <h1 className="hero-title">Empowering Education for All</h1>
            <p className="hero-subtitle">Transforming lives through quality education and innovative programs.</p>
            <Button variant="outline-light" className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Container>
        </div>
      </div>

      {/* Section 2: Our Vision */}
      <Container className="my-5">
        <Row className="align-items-center">
          <Col md={6} className="order-md-2">
            <img
              src="https://media.istockphoto.com/id/1316744041/photo/indian-poor-child-playing-at-home.jpg?s=612x612&w=0&k=20&c=g-pjbRh_GHq2ITWi-vVbSoszEusk_7K8g5MFZaDFBoc="
              alt="Children Learning"
              className="img-fluid rounded shadow-lg"
            />
          </Col>
          <Col md={6} className="order-md-1">
            <h2 className="section-title"><FontAwesomeIcon icon={faGraduationCap} className="me-2" /> Our Vision</h2>
            <p className="section-text">
              At Srisailam Foundation, we envision an India where every child has the opportunity to learn and thrive. We are committed to removing barriers to education by offering scholarships, digital learning resources, and community-driven support for underprivileged students nationwide.
            </p>
            <Button className="mt-3 donate-btn" onClick={handleDonateClick}>
              Donate Us
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Section 3: Educational Programs */}
      <Container className="my-5 py-5" style={{ backgroundColor: '#F3F4F6' }}>
        <h2 className="text-center section-title mb-5"><FontAwesomeIcon icon={faBook} className="me-2" /> Educational Programs</h2>
        <Row className="g-4">
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faBook} size="3x" className="mb-3 icon" />
                <Card.Title className="card-title">Scholarships</Card.Title>
                <Card.Text className="card-text">
                  Providing financial support to help students pursue their dreams, free from economic barriers.
                </Card.Text>
                <Button variant="outline-primary" size="sm" className="donate-btn" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faChalkboardTeacher} size="3x" className="mb-3 icon" />
                <Card.Title className="card-title">Online Learning</Card.Title>
                <Card.Text className="card-text">
                  Free access to high-quality online courses, empowering students of all ages to learn anytime, anywhere.
                </Card.Text>
                <Button variant="outline-primary" size="sm" className="donate-btn" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="h-100 border-0 shadow-sm program-card">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faGraduationCap} size="3x" className="mb-3 icon" />
                <Card.Title className="card-title">Mentorship</Card.Title>
                <Card.Text className="card-text">
                  Personalized guidance from experienced mentors to inspire and shape tomorrow’s leaders
                </Card.Text>
                <Button variant="outline-primary" size="sm" className="donate-btn" onClick={handleDonateClick}>
                  Donate Us
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Section 4: Impact and Support */}
      <Container className="my-5 text-center">
        <h2 className="section-title mb-4"><FontAwesomeIcon icon={faChalkboardTeacher} className="me-2" /> Make a Difference</h2>
        <p className="section-text mb-4">
          Your support can transform the lives of countless children through education. Join us in creating a brighter, more hopeful future.
        </p>
        <Button className="donate-btn" size="lg" onClick={handleDonateClick}>
          Donate Us
        </Button>
      </Container>
    </div>
  );
};

export default Education;